import { trimFieldString } from "../util.js";

export function translateDot2(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(oneD_dotplot_to_bar,"justice",horizontal).  
  let mark = args[0], field = trimFieldString(args[1]),
    direction = args[2],
    rc = (direction === "horizontal" ? "row" : "column"),
    layer = source?.layer?.[mapping[args[3]].layer];
  let rule_rc = {
    category: "recommender",
    description: `Add ${rc} fields`,
    specifier: { role: "view" },
    action: "add",
    option: {
      role: rc,
      field: field,
      type: "nominal"
    }
  };
  rules.push(rule_rc);
  if (mark === "bar") {
    let ops_rc = source.layout?.[(rc === "row" ? "column" : "row")] || [];
    let last_ops_rc = ops_rc[ops_rc.length - 1];
    if (last_ops_rc?.scale?.domain) {
      rules.push({
        category: "recommender",
        description: "Unset encoding scale domain",
        specifier: { role: "view." + (rc === "row" ? "column" : "row"), field: last_ops_rc.field },
        action: "modify",
        option: {
          scale: { domain: null }
        }
      });
    }
    rules.push({
      category: "recommender",
      description: `Change mark type to bar`,
      specifier: { role: "mark", mark: layer.mark.type },
      action: "modify",
      option: {
        type: "bar",
        size: null,
        opacity: { value: 0.7 }
      }
    });
  }
  return rules;
}